<button [disabled]="!isUpEnabled" (click)="moveUp()" class="sort-button">
    <fui-icon [height]="12" [icon]="'chevron-up'" [width]="12"></fui-icon>
</button>
<button [disabled]="!isDownEnabled" (click)="moveDown()" class="sort-button">
    <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
</button>

